export default [
    {
        path: "credit",
        name: "creditList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/index"),
    },
    {
        path: "credit/:type",
        name: "creditUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/update"),
    },
    // 发起保险
    {
        path: "credit/insurance/list",
        name: "insuranceList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/insured/index"),
    },
    {
        path: "credit/insurance/:type",
        name: "insuranceUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/insured/update"),
    },
    // 发起保险管理端
    {
        path: "credit/insurancemanage/list",
        name: "insuranceManageList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/insuredmanage/index"),
    },
    {
        path: "credit/insurancemanage/:type",
        name: "insuranceManageUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/insuredmanage/update"),
    },
    // 保险规则-客户组织
    {
        path: "credit/rulescustomerorg/list",
        name: "rulescustomerorgList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/rulescustomerorg/index"),
    },
    {
        path: "credit/rulescustomerorg/:type",
        name: "rulescustomerorgUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/rulescustomerorg/update"),
    },
    // 保险服务商管理
    {
        path: "credit/servicemanage/list",
        name: "rulesServicemanageList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/servicemanage/index"),
    },
    {
        path: "credit/servicemanage/:type",
        name: "rulesServicemanageUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/servicemanage/update"),
    },
    // 保险产品维护
    {
        path: "credit/prodmaintenance/list",
        name: "rulesProdmaintenanceList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/prodmaintenance/index"),
    },
    {
        path: "credit/prodmaintenance/:type",
        name: "rulesProdmaintenanceUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/prodmaintenance/update"),
    },
    // 保险产品映射
    {
        path: "credit/prodmappings/list",
        name: "rulesProdmappingsList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/prodmappings/index"),
    },
    {
        path: "credit/prodmappings/:type",
        name: "rulesProdmappingsUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/prodmappings/update"),
    },
    // 保险发货方式映射
    {
        path: "credit/deliveryway/list",
        name: "rulesDeliverywayList",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/deliveryway/index"),
    },
    {
        path: "credit/deliveryway/:type",
        name: "rulesDeliverywayUpdate",
        component: () => import(/* webpackChunkName: "credit" */ "@/views/credit/insurance/deliveryway/update"),
    },
]
